import { affectsLegacyProgress } from "./legacyProgressInvalidation";

let academicEpoch = 0;
if (typeof window !== "undefined") {
  const updated = (event) => { if (affectsLegacyProgress(event)) academicEpoch += 1; };
  ["legacy-collection-updated", "learner-quiz-completed", "learner-assessment-reviewed"]
    .forEach((event) => window.addEventListener(event, updated));
}

export const isObsoleteProgressRead = (error) => error?.code === "client/stale-progress";

const obsolete = (message) => Object.assign(new Error(message), { code: "client/stale-progress" });

// A response fetched before a saved assessment must never overwrite newer
// progress. Retry once after a write; an account switch always discards it.
export async function currentProgressRead(read, getIdentity) {
  const owner = getIdentity();
  const run = async (startEpoch, retry) => {
    if (getIdentity() !== owner) throw obsolete("The signed-in user changed during progress loading.");
    let result;
    let readError;
    let failed = false;
    try {
      result = await read();
    } catch (error) {
      failed = true;
      readError = error;
    }
    if (getIdentity() !== owner) throw obsolete("The signed-in user changed during progress loading.");
    if (startEpoch !== academicEpoch) {
      if (retry) return run(academicEpoch, false);
      throw obsolete("Assessments changed again during progress loading. Please refresh.");
    }
    if (failed) throw readError;
    return result;
  };
  return run(academicEpoch, true);
}
